import React, { Component } from "react";
import DashHeaderContainer from "../CommonComponents/Header/HeaderContainer";
import "./MainLayout.less"

class MainLayout extends Component {
  render() {
    return (
      <div id="mainLayout">
        <DashHeaderContainer history={this.props.history} />
        {this.props.children}
      </div>
    );
  }
}

export default MainLayout;
